import {Directive, OnDestroy} from "@angular/core";
import {ReplaySubject} from "rxjs";
import {ClassConstructor} from "class-transformer/types/interfaces";

@Directive()
export abstract class BaseComponent implements OnDestroy {
  protected componentDestroyed: ReplaySubject<void> = new ReplaySubject<void>(1);
  ngOnDestroy(): void {
    if(!this.componentDestroyed.closed) {
      this.componentDestroyed.next();
      this.componentDestroyed.complete();
    }
    this.componentDestroyed.unsubscribe();
  }

  trackById = (index: number, item: {Id: string}) => item?.Id;
}
